import { useCallback } from 'react';
import { useHash } from 'hooks/use-hash';

interface Result {
  userIdFromUrl?: number;
  hide: () => void;
  show: (userId: number) => void;
}
const people_drawer_key = 'people_drawer';

export const usePeopleDrawerParamsFromUrl = (): Result => {
  const [userId, setUserId] = useHash<number | undefined>({
    from: (parsed) => {
      const userIdParam = parsed[people_drawer_key];

      if (typeof userIdParam === 'string') {
        return parseInt(userIdParam, 10);
      }

      return undefined;
    },
    to: (userIdParam) => {
      return {
        [people_drawer_key]:
          userIdParam == null ? null : userIdParam.toString(),
      };
    },
  });
  const hide = useCallback(() => setUserId(undefined), [setUserId]);
  const show = useCallback((id: number) => setUserId(id), [setUserId]);

  return {
    userIdFromUrl: userId,
    hide,
    show,
  };
};
